/* eslint-disable no-extend-native */
// @ts-ignore

interface String {
  /**
   * Function to truncate words after a maximum number of characters.
   *
   * @param maxCharacters number of characters to then truncate the word
   * @returns string
   */
  truncate(maxCharacters: number): string

  /**
   * Function toTitleCase converts the first letter of each word
   * as long as it is not on the exceptions lists
   *
   * This method require these exceptions lists
   * @see uppersExceptions.ts
   * @see lowersExceptions.ts
   * @params string
   * @returns string
   * @example
   * string 'null' - returns null
   * string 'undefined' - returns null
   * string 'MARIA DA SILVA' - returns 'Maria da Silva Sauro'
   * string 'maria da silva' - returns 'Maria da Silva Sauro'
   * string 'mARia dA siLVA' - returns 'Maria da Silva Sauro'
   */
  titleCase(): string

  /**
   * Function toCapitalize converts the first letter of each phrase
   * as long as it is not on the exceptions lists
   *
   * This method require these exceptions lists
   * @see uppersExceptions.ts
   * @see lowersExceptions.ts
   * @params string
   * @returns string
   * @example
   * string 'null' - returns null
   * string 'undefined' - returns null
   * string 'MARIA DA SILVA' - returns 'Maria da silva sauro'
   * string 'maria da silva' - returns 'Maria da silva sauro'
   * string 'mARia dA siLVA' - returns 'Maria da silva sauro'
   */
  capitalize(): string
}

String.prototype.truncate = function (maxCharacters: number): string {
  return String(this).length > maxCharacters ? `${String(this).substring(0, maxCharacters)}...` : String(this)
}

String.prototype.titleCase = function (): string {
  const input = String(this)
  if (input === null || input === undefined) {
    return null
  }

  const splitedInput: string[] = input.trim().split(' ')

  return splitedInput
    .reduce((prev, curr) => {
      if (lowers.includes(prev.toLowerCase().trim())) {
        prev = prev.toLowerCase()
      }
      if (uppers.includes(prev.toUpperCase().trim())) {
        prev = prev.toUpperCase()
      }

      if (lowers.includes(curr.toLowerCase())) {
        return prev.trim() + ` ${curr.toLowerCase()}`
      } else if (uppers.includes(curr.toUpperCase())) {
        return prev.trim() + ` ${curr.toUpperCase()}`
      } else {
        if (curr.charAt(0) === '(') {
          return prev.trim() + ` (${curr.charAt(1).toUpperCase() + curr.slice(2).toLowerCase().trim()}`
        } else {
          return prev.trim() + ` ${curr.charAt(0).toUpperCase() + curr.slice(1).toLowerCase().trim()}`
        }
      }
    }, '')
    .trim()
}

String.prototype.capitalize = function (): string {
  let input = String(this)

  if (input === null || input === undefined) {
    return null
  }

  input = input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()

  const splitedInput: string[] = input.trim().split(' ')
  return splitedInput
    .reduce((prev, curr) => {
      if (lowers.includes(prev.toLowerCase().trim())) {
        prev = prev.toLowerCase()
      }
      if (uppers.includes(prev.toUpperCase().trim())) {
        prev = prev.toUpperCase()
      }

      if (lowers.includes(curr.toLowerCase())) {
        return prev + ` ${curr.toLowerCase()}`
      } else if (uppers.includes(curr.toUpperCase())) {
        return prev + ` ${curr.toUpperCase()}`
      } else {
        return prev + ` ${curr}`
      }
    }, '')
    .trim()
}

const lowers: string[] = [
  'de',
  'di',
  'do',
  'da',
  'dos',
  'das',
  'dello',
  'della',
  'don',
  'dalla',
  'dal',
  'del',
  'e',
  'ou',
  'com',
  'em',
  'na',
  'no',
  'nas',
  'nos',
  'van',
  'von',
  'às',
  'as',
]

const uppers: string[] = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
  'ACE',
  'ASB',
  'ACS',
  'AD',
  'TSB',
  'NASF',
  'UBS',
  'CS',
  'CIAP2',
  'CID10',
  'SIGTAP',
  'EN',
  'ESF',
  'ESFSB_M1',
  'ESFSB_M2',
  'EACS',
  'EPEN',
  'NASF1',
  'ENASF2',
  'EMSI',
  'EMSIAL',
  'EACSSB_M1',
  'EACSSB_M2',
  'ESFR',
  'ESFRSB_MI',
  'ESFF',
  'ESFFSB',
  'EAB II',
  'EAB1',
  'EAB2',
  'EAB3',
  'EAB1SB',
  'EAB2SB',
  'EAB3SB',
  'EMAD1',
  'EMAP',
  'ESB',
  'ESF1',
  'ESF1SB_M1',
  'ESF1SB_M2',
  'ESF2',
  'ESF2SB_M1',
  'ESF2SB_M2',
  'ESF3',
  'ESF3SB_M1',
  'ESF3SB_M2',
  'ESF4',
  'ESF4SB_M1',
  'ESF4SB_M2',
  'SFTRANS',
  'ESFTRANSSB_M1',
  'ESFTRANSSB_M2',
  'ESFRSB_MII',
  'ECR MI',
  'ECR MII',
  'ECR MIII',
  'ESB MII',
  'ESB MII',
  'NASF3',
  'EMAD2',
  'ECD',
  'ESSE',
  'EAP',
  'EABP-I',
  'ABP-I',
  'EABP-II',
  'EABP-II',
  'EABP-III',
  'I',
  'II',
  'III',
  'IV',
  'V',
  'VI',
  'VII',
  'VIII',
  'IX',
  'X',
  'IGG',
  'IGM',
  'HBSAG',
  'ABO',
  'TIA',
  '(TIA)',
  'HIV',
  'HIV-2',
  'EAS',
  'EQU',
  'ANTI-HIV-1',
  'HDL',
  'LDL',
]
